module.exports = __webpack_public_path__ + "media/images/logo_jortt-2f17fd32bd99067fd37e38dedb1b142f.svg";